export const ExperienceWorkModel = [
    
    {
        name: "ClickNext Co., Ltd.",
        role: "iOS Developer",
        startDate: new Date("2022-06-01"),
        workType: "Internship",
        endDate: new Date("2022-10-22")
    }, {
        name: "ClickNext Co., Ltd.",
        role: "iOS Developer",
        startDate: new Date("2023-07-03"),
        workType: "Full-time"
    }
    
]